<ng-template #DynamicComponentLoader dsDynamicComponentLoader></ng-template>
